import { Footer } from "../components/footer/footer";
import { Scroll } from "../components/scroll/scroll";
import { Header } from "../components/header/header";
import { useI18n } from '../i18n';
import { ContentIndex } from '../components/content-index';
import { FormattedText } from '../components/formatted-text/formatted-text';
import { Gallery, GalleryImage } from '../components/gallery/gallery';
import { Figure } from "../components/figure/figure";


export default function Career() {
    const { translations } = useI18n();

    return (
        <Scroll>
            <main className="page">
                <Header
                    title={translations.career.title}
                    // description={translations.career.description}
                    breadcrumbs={[
                        { label: 'GAraujo', href: '/' },
                        { label: translations.career.title, href: '/career' },
                    ]}
                />
                <ContentIndex />
                <div className="content">

                <section>
                    <article>
                        <h2 id="design-product-collaboration">{translations.career.section1Title}</h2>
                        <p>{translations.career.section1p1}</p>
                        <p>{translations.career.section1p2}</p>
                        <p>{translations.career.section1p3}</p>
                        {/* <p>{translations.career.section1p4}</p> */}
                    </article>
                    <article>
                        <h2 id="background">{translations.career.historyTitle}</h2>
                        <Gallery images={[
                            { src: "/img/photos/modulo-ex-estagiarios-2003-agosto-foto-o-globo.jpg", alt: "Ex-estagiárias da Módulo - 2003", caption: "Jornal O GLOBO / caderno BOA CHANCE | Turma de ex-estagiários da Módulo que foi efetivada.", grayscale: true }
                        ]} />
                        <p>{translations.career.historyP1}</p>
                        <p>{translations.career.historyP2}</p>
                        <p>{translations.career.historyP3}</p>
                    </article>

                    <article>
                        <h2 id="recognition-and-impact">{translations.career.recognitionTitle}</h2>
                        <FormattedText html={translations.career.recognitionHtml} />

                        <Gallery images={[
                            { src: "/img/awards/award-apple-criativity-shortlist.jpg", alt: "Ranked among the 5 finalists for the Apple Digital Creativity Award", caption: "Ranked among the 5 finalists for the Apple Digital Creativity Award.", grayscale: true }
                        ]} />
                       
                        <FormattedText html={translations.career.recognitionHtml2} />
                    </article>

                    <article>
                        <h2 id="moments">{translations.career.collaborationsTitle}</h2>
                        <p>{translations.career.collaborationsP1}</p>
                    </article>

                    </section>
                    <Gallery
                        images={[
                            { src: "/img/photos/work-environment.jpg", alt: "Home Office (RJ)", grayscale: true },
                            { src: "img/photos/photo-team-bh.jpg", alt: "Team Plurall (BH)", grayscale: true },
                            { src: "/img/photos/show-dont-tell.jpg", alt: "Home Office (RJ)", grayscale: true },
                            { src: "/img/photos/photo-team-ipanema-party2.jpg", alt: "Team Edumobi (RJ)", grayscale: true },
                        ]}
                    />
                    <Footer />
                </div>
            </main >
        </Scroll>
    );
}